/* eslint-disable no-unused-vars */
import UilAngleDown from '@iconscout/react-unicons/icons/uil-angle-down';
import UilSignout from '@iconscout/react-unicons/icons/uil-signout';
import UilPassword from '@iconscout/react-unicons/icons/uil-key-skeleton';
import { Button, Tag } from 'antd';
import moment from 'moment';

import React, { createRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

import { InfoWraper, UserDropDwon } from './auth-info-style';
import Notification from './Notification';
import ChangePasswordDialog from './change-password'; // Import the new component

import { logOut } from '../../../redux/authentication/actionCreator';

import Heading from '../../heading/heading';
import { Popover } from '../../popup/popup';
import { changeLayoutMode } from '../../../redux/themeLayout/actionCreator';
import { USER_ROLES } from '../../../config/config';
import { themeColor } from '../../../config/theme/themeVariables';

const popRef = createRef(null);
const AuthInfo = React.memo(() => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authUser = useSelector((reduxState) => reduxState.auth)
  const userData = authUser?.data || {}

  const [isChangePasswordVisible, setChangePasswordVisible] = useState(false);

  const openChangePasswordDialog = () => {
    popRef.current.setPopupVisible(false);
    setChangePasswordVisible(true)
  };
  const closeChangePasswordDialog = () => setChangePasswordVisible(false);


  const SignOut = (e) => {
    e.preventDefault();
    dispatch(logOut(() => navigate('/')));
  };

  const userContent = (
    <UserDropDwon>
      <div className="min-w-52 user-dropdwon">
        <figure className="user-dropdwon__info">
          <div className='flex flex-col text-center w-full'>
            <Heading as="h5"><strong>{userData.full_name}</strong></Heading>
            <div className='bg-black ' style={{ minHeight: '1px' }} />
            <Heading as="h6"><strong>{userData.role}</strong></Heading>
          </div>
        </figure>
        <ul className="user-dropdwon__links">
          <li>
            <Button
              type="text"
              className='flex !bg-white text-align-center items-center justify-center ninjadash-delete hover:scale-105 hover:text-orange-400 hover:cursor-pointer transform transition duration-300 ease-in-out'
              onClick={openChangePasswordDialog}
            >
              <UilPassword />
              &nbsp;&nbsp;Change Password
            </Button>
          </li>
        </ul>
        <Link className="user-dropdwon__bottomAction hover:scale-10 hover:border-dotted hover:border-2 hover:border-sky-500 transform transition duration-300 ease-in-out" onClick={SignOut} to="#">
          <UilSignout /> Sign Out
        </Link>
      </div>
    </UserDropDwon>
  );

  const changeLayout = (mode) => {
    dispatch(changeLayoutMode(mode));
  };

  const getSubscriptionChip = () => {
    if (userData && userData.api_url === USER_ROLES.COMPANY) {
      let color = themeColor['danger-color'];
      let lblStr = 'No Subscription';
      let lblMsg = 'Your Subscription will expire at';
      let isExpired = false;
      let isExpiringSoon = false;
      const text = userData.renewal_valid_upto;
      let daysLeft = 1;
      if (text) {
        if (moment(text).isValid()) {
          lblStr = moment(text).format('D MMM YYYY');
          const today = moment().startOf('day');
          const validUpto = moment(text).startOf('day');
          daysLeft = validUpto.diff(today, 'days');

          if (daysLeft > 0) {
            if (daysLeft <= 10) {
              isExpiringSoon = true;
              lblMsg = `Your Subscription will expire in ${daysLeft} day${daysLeft > 1 ? 's' : ''}`;
              color = `rgba(0, 0, 0, ${1 - daysLeft / 11})`; // Gradually darkens as days decrease
            } else {
              color = themeColor['success-color'];
            }
          } else {
            isExpired = true;
            lblMsg = 'Your Subscription is expired';
            color = themeColor['danger-color'];
          }
        }
      }

      return (
        <div
          className={`flex justify-content-center ${isExpired ? 'animate-bounce' : ''
            }`}
        >
          <div className='taglist-wrap select-none text-black'>
            {lblMsg} &nbsp;<Tag color={color} className={isExpired ? 'font-bold text-lg' : isExpiringSoon && daysLeft > 8 ? 'text-black' : ''}>
              {lblStr}
            </Tag>
          </div>
        </div>
      );
    }
  };

  return (
    <InfoWraper>
      {getSubscriptionChip()}
      <ChangePasswordDialog
        isVisible={isChangePasswordVisible}
        onClose={closeChangePasswordDialog}
      />
      <Notification />
      <div className="ninjadash-nav-actions__item ninjadash-nav-actions__author">
        <Popover popRef={popRef} ref={popRef} placement="bottomRight" content={userContent} action="click">
          <Link to="#" className="ninjadash-nav-action-link bg-gray-100 rounded-md	mt-1 hover:border-dotted hover:border-2 hover:border-sky-500">
            <img alt='test' src={require('../../../static/img/icon/user.png')} style={{ height: 25, width: 25 }} />
            <span className="ninjadash-nav-actions__author--name">{userData.full_name}</span>
            <UilAngleDown />
          </Link>
        </Popover>
      </div>
    </InfoWraper>
  );
});

export default AuthInfo;
